<div *ngIf="successMessage">
  <div class="text-center email-sent-content">
    <h1 class="display-4 mb-20">Email sent</h1>
    <p class="note-text mb-20">
      We have sent you an email to <span class="fw-bold">{{this.successMessage}}</span> with a link to reset your
      password.
    </p>
    <p class="info-text mb-20">Didn't get the email? Check your spam folder or</p>
    <button type="submit" class="btn btn-primary mb-20" [disabled]="loading || !resendTimeout || !resendTimeout.isFinish()" (click)="onSubmit()">
      <ng-container *ngIf="!loading">Resend email {{ resendTimeout.formatSeconds() }}</ng-container>
      <i *ngIf="loading" class="icon icon-wait spin"></i>
    </button>
    <div class="forgot-link">
      <a [routerLink]="['/login']" class="text-primary">Remember it? Log in</a>
    </div>
  </div>
</div>

<div *ngIf="!successMessage">
  <h1 class="display-4 mb-20">Forgot your password?</h1>

  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <p class="text-center">
      Please, enter username or email address related with your account and we'll send you a link to reset your
      password.
    </p>
    <div class="form-group">
      <label for="username" class="form-label">Username or Email</label>
      <input [(ngModel)]="model.username" formControlName="username" type="text" class="form-control" placeholder="" required />
      <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid || loading">
      <ng-container *ngIf="!loading">Reset Password</ng-container>
      <i *ngIf="loading" class="icon icon-wait spin"></i>
    </button>
  </form>

  <div class="forgot-link text-center mt-20">
    <a [routerLink]="['/login']"> Remember it? Log in </a>
  </div>
</div>
